import { useNavigate } from 'react-router';

import lang from '../../../../lib/language';

import Button from '../../../../shared_components/Button/Button';
import { UI_ROUTES } from '../../../../util/routes';

import styles from './Modal.module.scss';

type Props = {
  title: string;
  descriptionComponent?: React.ReactElement;
  description1?: string;
  description2?: string;
};

const Modal = ({ title, descriptionComponent, description1, description2 }: Props) => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapperModal}>
      <h6 className={styles.title}>{title}</h6>
      {descriptionComponent}
      {!descriptionComponent && (
        <>
          <span className={styles.description}>{description1}</span>
          <span className={styles.description}>{description2}</span>
        </>
      )}
      <Button
        fullWidth
        biggerFontSize
        onClick={() => navigate(UI_ROUTES.payouts + UI_ROUTES.payoutsMethods)}
      >
        {lang.commonOkay()}
      </Button>
    </div>
  );
};

export default Modal;
